import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useToast } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { useGetFilePdfUrl } from './useGetFilePdfUrl';

export const AppointmentPdfPage: React.FC = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { tenantId, appointmentId } = useParams() as {
    tenantId: string;
    appointmentId: string;
  };

  const handlePdf = useGetFilePdfUrl({
    appointmentId,
    tenantId,
    type: 'CHART',
  });

  useEffect(() => {
    (async () => {
      const response = await handlePdf();
      if (response.status === 201) {
        window.location.href = response.body.pdfUrl;
      } else {
        toast.error(t('appointmentTools.common.generatePdfFailed'));
      }
    })();
  }, [handlePdf, toast, t]);

  return null;
};
